// extracted by mini-css-extract-plugin
export default {"rating":"wH-z","numberOfStars":"xH-z","count":"yH-z","barGraphSpacing":"zH-z","barGraph":"AH-z"};